import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Button, Modal } from 'components/Base';
import Icons from 'components/Icons';
import moment from 'moment';

interface UnsavedAnalysisModalProps {
  isModalOpen: boolean;
  onClose: Function;
  researchItems: any;
  triggerDelete: Function;
  updateCurrentResearchItem: Function;
}

const UnsavedAnalysisModal = ({
  isModalOpen,
  onClose,
  researchItems,
  triggerDelete,
  updateCurrentResearchItem
}: UnsavedAnalysisModalProps) => {
  const useStyles = makeStyles(() =>
    createStyles({
      modal: {
        width: '500px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        maxHeight: '80vh',
        overflow: 'auto'
      }
    })
  );

  const classes = useStyles();

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => onClose()}>
      <BoxWrapper title="Unsaved Analysis" closeModal={() => onClose()}>
        <div className={classes.modal}>
          All unsaved analysis will be deleted after 48 hours
          {researchItems
            .sort((a: any, b: any) => (a.created_at > b.created_at ? -1 : 1))
            .map((researchItem: any, i: number) => (
              <div key={i} style={{ display: 'flex' }}>
                <div style={{ width: '100%', fontWeight: '700' }}>
                  Quick Analysis
                  {researchItem.user &&
                    researchItem.user.first_name &&
                    researchItem.user.last_name && (
                      <>
                        {' '}
                        by {researchItem.user.first_name}{' '}
                        {researchItem.user.last_name} -{' '}
                      </>
                    )}
                  {moment(researchItem.created_at).format(
                    'DD/MM/YYYY HH:mm:ss'
                  )}
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%',
                    justifyContent: 'flex-end',
                    gap: '10px'
                  }}
                >
                  <div
                    className="cipThresholdDelete"
                    onClick={() => {
                      triggerDelete(researchItem);
                      onClose();
                    }}
                  >
                    <Icons.DeleteIcon />
                  </div>
                  <Button
                    type="submit"
                    onClick={() => {
                      updateCurrentResearchItem(researchItem.value);
                      onClose();
                    }}
                    style={{ marginLeft: '1rem' }}
                  >
                    View Analysis
                  </Button>
                </div>
              </div>
            ))}
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default UnsavedAnalysisModal;
